//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @param patientId (optional) Patient id
 * @param from (optional) Summary period start date
 * @param until (optional) Summary period end date
 * @param aggregationPeriod (optional) The period for which data should be aggregated
 * @param deviceParameter (optional) Type of statistics for summary
 */
export function getDeviceDataSummary(patientId?: string | undefined, from?: Date | undefined, until?: Date | undefined, aggregationPeriod?: Types.AggregationPeriodEnum | undefined, deviceParameter?: Types.SummaryCalculatorEnum | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SummaryDto> {
    let url_ = getBaseUrl() + "/api/deviceData/summary?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (from === null)
        throw new Error("The parameter 'from' cannot be null.");
    else if (from !== undefined)
        url_ += "From=" + encodeURIComponent(from ? "" + Types.formatDate(from) : "") + "&";
    if (until === null)
        throw new Error("The parameter 'until' cannot be null.");
    else if (until !== undefined)
        url_ += "Until=" + encodeURIComponent(until ? "" + Types.formatDate(until) : "") + "&";
    if (aggregationPeriod === null)
        throw new Error("The parameter 'aggregationPeriod' cannot be null.");
    else if (aggregationPeriod !== undefined)
        url_ += "AggregationPeriod=" + encodeURIComponent("" + aggregationPeriod) + "&";
    if (deviceParameter === null)
        throw new Error("The parameter 'deviceParameter' cannot be null.");
    else if (deviceParameter !== undefined)
        url_ += "DeviceParameter=" + encodeURIComponent("" + deviceParameter) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDeviceDataSummary,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDeviceDataSummary(_response);
    });
}

function processGetDeviceDataSummary(response: AxiosResponse): Promise<Types.SummaryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SummaryDto.fromJS(resultData200);
        return Promise.resolve<Types.SummaryDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SummaryDto>(null as any);
}
let _requestConfigGetDeviceDataSummary: Partial<AxiosRequestConfig> | null;
export function getGetDeviceDataSummaryRequestConfig() {
  return _requestConfigGetDeviceDataSummary;
}
export function setGetDeviceDataSummaryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDeviceDataSummary = value;
}
export function patchGetDeviceDataSummaryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDeviceDataSummary = patch(_requestConfigGetDeviceDataSummary ?? {});
}